import * as React from 'react';
import { SVGProps, memo } from 'react';

/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
const SvgDiamondPriceCircle = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 16 16"
    {...props}
  >
    <path
      fill="url(#diamond-price-circle_svg__a)"
      fillRule="evenodd"
      d="M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"
      clipRule="evenodd"
    />
    <path
      stroke="#fff"
      d="M10.625 3.333h-5.25L2.167 6.25l5.833 7 5.833-7-3.208-2.917zM2.167 6.25h11.666"
    />
    <path
      stroke="#fff"
      d="M5.375 3.333 4.5 6.25 8 12.667l3.208-6.417-.583-2.917"
    />
    <path stroke="#fff" d="M4.5 6.25 8 3.625l3.208 2.625" />
    <defs>
      <linearGradient
        id="diamond-price-circle_svg__a"
        x1={16}
        x2={16}
        y1={16}
        y2={0}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#50E2C2" />
        <stop offset={1} stopColor="#26BBD9" />
      </linearGradient>
    </defs>
  </svg>
);
const Memo = memo(SvgDiamondPriceCircle);
export default Memo;
